import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SearchInput } from '~/components/header-navigation/components/search-input/SearchInput';
import { breakpoints } from '~/design-tokens/breakpoints/breakpoints';
import { ColorScheme } from '~/design-tokens/themes/themes';

import {
  HeaderCategory,
  HeaderCategoryGroup,
} from './components/category-group/HeaderCategoryGroup';
import * as S from './HeaderNavigation.styles';

export interface HeaderNavigationProps {
  activeKey?: string;
  categories: HeaderCategory[];
  categoriesOptions: HeaderCategory[];
  className?: string;
  colorScheme?: ColorScheme;
  disabledKeys?: string[];
  onLogoClick: () => void;
  onSearchClick: () => void;
}

export const HeaderNavigation: FC<HeaderNavigationProps> = ({
  activeKey,
  categories,
  categoriesOptions,
  colorScheme,
  disabledKeys,
  onLogoClick,
  onSearchClick,
}) => {
  const { t } = useTranslation('common');
  const mediaQuery = window.matchMedia(breakpoints.xlg);
  const [isLargeScreen, setIsLargeScreen] = useState(mediaQuery.matches);

  useEffect(() => {
    const handleChange = () => setIsLargeScreen(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return (
    <S.Header data-testid="header-navigation">
      <S.LogoButton onClick={onLogoClick}>
        <S.StyledLogotype colorScheme={colorScheme} />
      </S.LogoButton>

      <S.Categories>
        <SearchInput
          onClick={onSearchClick}
          placeholder={
            isLargeScreen
              ? t('common:sideNavigation.searchPlaceholder')
              : t('common:sideNavigation.smallSearchPlaceholder')
          }
        />
        {categories.map(category => (
          <HeaderCategoryGroup
            key={category.id ?? category.title}
            category={category}
            activeKey={activeKey}
            disabledKeys={disabledKeys}
          />
        ))}
      </S.Categories>

      <S.Categories>
        {categoriesOptions.map(category => (
          <HeaderCategoryGroup
            key={category.id ?? category.title}
            category={category}
            activeKey={activeKey}
            disabledKeys={disabledKeys}
          />
        ))}
      </S.Categories>
    </S.Header>
  );
};
